'use strict';

export default class{
	/*@ngInject*/
	constructor($http){
		this.$http = $http;
		this.loaded = true;
		this.tutor = {
			nameFirst: '',
			nameLast: '',
			state: '',
			crmID: '',
			invoiceCode: '',
			wwcID: '',
			wwcExpires: '',
			wwcState: '',
		};
		this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
	}

	create(callback){
		this.success = null;
		this.$http.post('/api/tutors', this.tutor).then(res => {
			this.tutor = {};
			callback();
		})
	}
}


// WEBPACK FOOTER //
// ./client/app/modals/create-tutor/create-tutor.controller.js